// src/pages/marketplace/OrderSuccess.jsx
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function OrderSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div style={{ maxWidth: 600, margin: '4rem auto', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎉</div>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#10b981' }}>Payment Successful!</h1>
      <p style={{ color: '#aaa', marginTop: '1rem', lineHeight: 1.6 }}>
        Thank you for your purchase. Your payment has been securely processed by Stripe and your order status is now marked as <strong>Paid</strong>.
      </p>
      
      {sessionId && (
        <div style={{
          background: '#1a1a2e',
          borderRadius: '1rem',
          padding: '1.5rem',
          marginTop: '2rem',
          textAlign: 'left',
          fontSize: '0.9rem',
          color: '#888'
        }}>
          <p style={{ margin: 0 }}><strong>Session ID:</strong></p>
          <code style={{ color: '#7c3aed', wordBreak: 'break-all' }}>{sessionId}</code>
        </div>
      )}

      <div style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', justifyContent: 'center' }}>
        <Link 
          to="/marketplace" 
          style={{
            padding: '0.8rem 1.5rem',
            background: '#7c3aed',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '0.5rem',
            fontWeight: 600
          }}
        >
          Back to Marketplace
        </Link>
        <Link 
          to="/marketplace/track" 
          style={{
            padding: '0.8rem 1.5rem',
            background: '#333',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '0.5rem',
            fontWeight: 600
          }}
        >
          Track Order
        </Link>
      </div>
    </div>
  );
}
